<div *ngIf="details" class="details-container" role="region"
  [attr.aria-label]="'iaa.app.hbSection.detailsRegion' | translate">
  <div class="content-wrapper">
    <div class="details">
      <app-accordion-panel class="general-panel"
        [header]="'iaa.app.hbSection.general' | translate"
        [selected]="true"
        [currentLanguage]="currentLanguage">
      <!-- No report name: it is the same field the page title already shows. -->
      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.projectNumber' | translate }}</div>
          <div class="value">{{ details.projectNumber || '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.archaeologist' | translate }}</div>
          <div class="value">{{ details.archaeologist || '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.merchav' | translate }}</div>
          <div class="value">{{ details.merchav || '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.executionDates' | translate }}</div>
          <div class="value"><span dir="ltr">{{ executionDates || '-' }}</span></div>
        </div>
      </div>

      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.numOfPoints' | translate }}</div>
          <div class="value">{{ details.numOfPoints ?? '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.numOfLine' | translate }}</div>
          <div class="value">{{ details.numOfLine ?? '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.app.hbSection.numOfPolygon' | translate }}</div>
          <div class="value">{{ details.numOfPolygon ?? '-' }}</div>
        </div>
        <div class="item-container span-2">
          <div class="label">{{ 'iaa.app.hbSection.reportTitle' | translate }}</div>
          <div class="value ellipsis" [title]="details.reportTitle || ''">{{ details.reportTitle || '-' }}</div>
        </div>
      </div>
      </app-accordion-panel>

      <div class="findings-section">
        <div class="findings-header">
          <div class="findings-title">
            {{ ('iaa.app.hbSection.findings' | translate) + ' (' + findings.length + ')' }}
          </div>
          <!-- Toggling a filter changes the row count silently; announce it. -->
          <div aria-live="polite" aria-atomic="true" class="sr-only">
            {{ ('iaa.app.hbSection.findings' | translate) + ' (' + findings.length + ')' }}
          </div>
          <div class="findings-filters" role="group" *ngIf="findings.length"
            [attr.aria-label]="'iaa.app.hbSection.filterFindings' | translate">
            <div class="switch-wrapper">
              <p-inputSwitch inputId="hb-in-report-switch"
                [(ngModel)]="inReportOnly"
                (onChange)="inReportOnlyChange.emit(inReportOnly)" />
              <label for="hb-in-report-switch">{{ 'iaa.app.hbSection.filter.inReport' | translate }}</label>
            </div>
            <div class="switch-wrapper">
              <p-inputSwitch inputId="hb-photos-switch"
                [(ngModel)]="withPhotosOnly"
                (onChange)="withPhotosOnlyChange.emit(withPhotosOnly)" />
              <label for="hb-photos-switch">{{ 'iaa.app.hbSection.filter.photos' | translate }}</label>
            </div>
          </div>
        </div>

        <div class="findings-scroll" *ngIf="findings.length" tabindex="0" role="region"
          [attr.aria-label]="('iaa.app.hbSection.findings' | translate) + ' (' + findings.length + ')'">
        <table class="findings-table">
          <caption class="sr-only">{{ 'iaa.app.hbSection.findings' | translate }}</caption>
          <thead>
            <tr>
              <th scope="col">{{ 'iaa.app.hbSection.snumber' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.geometryType' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.hbTypeName' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.remarks' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.element' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.period' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.depth' | translate }}</th>
              <th scope="col">{{ 'iaa.app.hbSection.photos' | translate }}</th>
              <th scope="col"><span class="sr-only">{{ 'iaa.general.map' | translate }}</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let finding of findings">
              <td>{{ finding.snumber ?? '-' }}</td>
              <td>{{ geometryLabel(finding.geometryType) | translate }}</td>
              <td>{{ finding.hbTypeName || '-' }}</td>
              <td class="wrap">{{ finding.remarks || '-' }}</td>
              <td>{{ finding.element || '-' }}</td>
              <td>{{ finding.period || '-' }}</td>
              <td>{{ finding.depth || '-' }}</td>
              <td class="photo-cell">
                <div class="finding-photos" *ngIf="finding.images.length">
                  <div class="finding-gallery">
                    <app-image-gallery [images]="images(finding)" [thumbnails]="thumbnails(finding)"
                      [objectName]="('iaa.app.hbSection.photos' | translate)" />
                  </div>
                </div>
              </td>
              <td class="map-cell">
                <span class="map-icon" [class.selected]="selectedEntityId === finding.entityId"
                  role="button" [tabindex]="0"
                  [attr.aria-pressed]="selectedEntityId === finding.entityId"
                  [attr.aria-label]="'iaa.app.hbSection.showOnMap' | translate"
                  [title]="'iaa.app.hbSection.showOnMap' | translate"
                  (click)="onMapIconClick(finding, $event)"
                  (keydown.enter)="onMapIconClick(finding, $event)"
                  (keydown.space)="onMapIconClick(finding, $event); $event.preventDefault()">
                  <img [src]="selectedEntityId === finding.entityId
                        ? 'assets/entity-location-blue.svg' : 'assets/entity-location-gold.svg'"
                    width="20" height="22" alt="" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="findings-empty" *ngIf="!findings.length">
          {{ 'iaa.app.hbSection.noFindings' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
